

<template>
    <div v-if="item" class="m-child-item" :class="{active: active}" @click="$emit('detail', item)">
        <div class="m-child-header">
            <div class="u-text">
                {{item.Name}}
            </div>
            <div class="u-cj-status" >
                <div class="u-top">
                    <div class="u-num">
                        {{item.Point}}
                    </div>
                    <div class="u-icon">
                        <svg data-name="图层 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="currentColor" class="cls-1" d="M114.2 171.14c-20.33 4.3-22.22 28.45-25.82 44.73-.85 3.85-2.36 13.49-6.85 14.91-8.16 2.57-4.4-18.14-4.27-21.91a525.52 525.52 0 016.46-64c2.11-13.48-.62-27.41-4-40.43-2-7.54-2.9-16.5-8.21-22.61-2.93-3.37-6.78-4.37-10.84-5.66A124.51 124.51 0 0040 72c-.24 0-.52 0-.62-.27s.15-.41.31-.57c7-7.34 20.48-15.44 30.88-14.44 5 .48 13 4.84 17.89 2.26 6.54-3.52 4.67-14.2 4.34-20.18-.26-4.69-.66-6.6 5.07-6.5 1.45 0 3.16.18 3.92 1.42a4.36 4.36 0 01.44 2.18c.23 8.07-1.09 16.22.61 24.21 2 9.29 11 16.15 20.64 11.94 4.78-2.08 8-6.06 12.17-9 12.83-8.85 28.41-13.26 43.87-14.14 17.77-1 36.11 1.37 49.66 13.94 1.23 1.14 2.48 2.51 2.53 4.19.09 3.41-5.88 3.27-8.12 3.5-14.59 1.51-29.87 4.71-42.5 12.46-13.82 8.47-20.93 20.72-22.86 36.66-2.28 18.84-.6 37 3.65 55.31 2.56 11 2.46 21.16 2.55 32.4 0 5.43.31 6.4-.16 12-.25 2.95-.61 9.3-2.91 11.41-4.54 4.15-8.07-19.31-8.7-21.73-3.34-12.94-10.15-25.37-20.48-33.94-4.76-3.92-12.01-5.23-17.98-3.97z"/></svg>
                    </div>
                </div>
            </div>
        </div>
        <div class="m-child-item__content" :class="[contentAlignClass]">
            <div class="u-img">
                <img
                    :src="icon_url(item.IconID)"
                     @error.once="
                            () => {
                                $event.target.src = icon_url();
                            }
                        "
                >
            </div>
            <div ref="desc" class="u-desc">
                {{item.Desc}}
            </div>
        </div>
    </div>
</template>

<script lang="js">
import { iconLink } from "@jx3box/jx3box-common/js/utils";

export default {
    name: "ChildItem",
    props: {
        item: {
            type: Object,
            default: () => {},
        },
        active:{
            type: Boolean,
            default: false
        }
    },
    emits: ["detail"],
    data() {
        return {
            isOneLine: true
        };
    },
    computed: {
        contentAlignClass() {
            return this.isOneLine ? 'is-center' : 'is-start';
        },
        currentRole() {
            return this.$store.state.role;
        },
        completeAchievements() {
            return this.$store.state.achievements || [];
        },
        achievementsVirtual() {
            return this.$store.state.achievementsVirtual || [];
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.checkLineCount();
        });
    },
    updated() {
        this.$nextTick(() => {
            this.checkLineCount();
        });
    },
    methods: {
        icon_url: function (id) {
            return iconLink(id, this.client);
        },
        hadCompleted(id) {
            const list = this.isVirtual ? this.achievementsVirtual : this.completeAchievements;
            return list.includes(id + "");
        },
        checkLineCount() {
            const descEl = this.$refs.desc;
            if (!descEl) return;

            // 临时移除行数限制来检测实际高度
            const actualHeight = descEl.scrollHeight;
            // 20px 是单行高度
            this.isOneLine = actualHeight <= 20;
        }
    },
}
</script>

<style lang="less">
.m-child-item{
    display: flex;
    padding: 20px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    width: 100%;
    box-sizing: border-box;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.10);
    &.active{
        padding: 16px;
        border-radius: 12px;
        border: 4px solid #FEDAA3;
        background: rgba(255, 255, 255, 0.10);
    }




    .m-child-header{
        position: relative;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        width: 100%;
        gap: 8px;

        .u-text{
            color: rgba(255, 255, 255, 0.80);

            /* 16 Bold */
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: 24px; /* 150% */
        }

        .u-cj-status{
            position: absolute;
            top: 0px;
            right: 0px;
            z-index: 2;

            .u-top{
                display: flex;
                gap: 4px;
                align-items: center;
            }
            .u-num{
                color: var(--black-20, rgba(255, 255, 255, 0.20));
                /* 12 Regular */
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                line-height: 18px; /* 150% */
            }

            .u-complete{
                color: var(--secondary-orange, #FF9500);
                /* 12 Bold */
                font-size: 12px;
                font-style: normal;
                font-weight: 700;
                line-height: 18px; /* 150% */
                display: block;
                text-align: right;
            }

            .u-icon{
                width: 16px;
                height: 16px;
                color: var(--black-20, rgba(28, 28, 28, 0.20));
            }

        }



    }
    .u-title{
        color: rgba(255, 255, 255, 0.80);

        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px; /* 150% */
    }

    .m-child-item__content{
        display: flex;
        gap: 8px;

        .u-img{
            width: 32px;
            height: 32px;
            border-radius: 4px;
            overflow:  hidden;
        }

        .u-desc{
            color: rgba(255, 255, 255, 0.80);
            /* 14 Regular */
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px; /* 142.857% */

            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
        }

        &.is-center{
            align-items:  center;
        }
        &.is-start{
            align-items:  flex-start;
        }
    }

}
</style>
